import type { TenantSelectionConflicts } from '../../../../components/tenant-selector/types';
import styles from './TenantSelectionControl.module.css';

interface TenantSelectionValidationStatusProps {
  conflicts: TenantSelectionConflicts;
  isValidating: boolean;
}

export function TenantSelectionValidationStatus({
  conflicts,
  isValidating,
}: TenantSelectionValidationStatusProps) {
  if (isValidating) {
    return <p className={styles.validatingMessage}>Validating...</p>;
  }
  return (
    <div className={styles.segmentConflictWarning} role="alert">
      <p className={styles.segmentConflictTitle}>{conflicts.notice.title}</p>
      <p className={styles.segmentConflictDescription}>{conflicts.notice.description}</p>
      <ul className={styles.segmentConflictList}>
        {conflicts.items.map(conflict => (
          <li key={conflict.tenantId}>
            <strong>{conflict.tenantName}</strong> {conflict.description}
          </li>
        ))}
      </ul>
    </div>
  );
}
